/**
 * moray-card-swap.js — segunda foto de la tarjeta de producto.
 *
 * El cambio en si lo hace el CSS (:hover en escritorio, .is-swapped en
 * tactil). Aqui solo queda lo que el CSS no puede: rellenar la foto MODELO,
 * que nace sin `src` para no descargarla de mas. El mismo contrato sirve para
 * home, PLP, busqueda, relacionados y sidecart.
 *
 * Reglas aprendidas a golpes:
 *  · NADA de listeners de click en captura con preventDefault: se tragaban
 *    clics de toda la tienda (enlaces que no navegaban).
 *  · Los handlers salen en O(1) cuando el evento no cae en una tarjeta; el
 *    calculo caro (buscar un carrusel entre los ancestros) se hace UNA vez
 *    por tarjeta y se guarda en su dataset.
 */
(function () {
  'use strict';
  if (window.__morayCardSwap) return;
  window.__morayCardSwap = true;

  var SEL = 'iurop-card-media';

  function media(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    return t.closest('.' + SEL);
  }

  function hydrate(img) {
    if (!img) return;
    var ss = img.getAttribute('data-card-model-srcset');
    if (ss) img.setAttribute('srcset', ss);
    img.setAttribute('src', img.getAttribute('data-card-model-src'));
    img.removeAttribute('data-card-model-src');
    img.removeAttribute('data-card-model-srcset');
  }

  function fillDeferred(el) {
    hydrate(el.querySelector('img[data-card-model-src]'));
  }

  window.__morayCardFill = fillDeferred;

  // Precarga escalonada: cuando una tarjeta entra en pantalla se pide su 2a
  // foto en el primer hueco de CPU. Asi no se descargan las de toda la pagina
  // de golpe (una home tiene decenas) pero al pasar el raton ya esta lista.
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 400); };
  var io = ('IntersectionObserver' in window)
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          idle(function () { fillDeferred(en.target); }, { timeout: 3000 });
        });
      }, { rootMargin: '100px' })
    : null;

  function observeAll() {
    if (!io) return;
    document.querySelectorAll('.' + SEL + ':not([data-swap-obs])').forEach(function (el) {
      el.dataset.swapObs = '1';
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeAll);
  else observeAll();
  document.addEventListener('shopify:section:load', observeAll);

  // Escritorio: el :hover del CSS ya cambia la foto; aqui solo se rellena la
  // diferida la primera vez que el raton entra.
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType === 'touch') return;
    var el = media(e);
    if (el) fillDeferred(el);
  }, { passive: true });

  // Tactil: mientras el dedo esta encima se ve la segunda foto; si el gesto
  // acaba siendo un deslizamiento en una rejilla (no en un carrusel, donde el
  // dedo mueve el track), se queda fijada.
  var node = null, sx = 0, sy = 0, holdTimer = null, swapped = false, holdOnly = false;
  var HOLD_MS = 320;   // mantener pulsado
  var SWIPE_PX = 24;   // deslizar

  function clearHold() {
    if (holdTimer) { clearTimeout(holdTimer); holdTimer = null; }
  }

  function swap(el) {
    if (swapped) return;
    swapped = true;
    fillDeferred(el);
    // ALTERNA: un deslizamiento ensena la segunda foto y el siguiente vuelve a
    // la primera (antes se quedaba fijada y no habia forma de volver).
    el.classList.toggle('is-swapped');
  }

  document.addEventListener('touchstart', function (e) {
    node = null;
    clearHold();
    swapped = false;
    if (e.touches.length !== 1) return;
    var el = media(e);
    if (!el) return;
    node = el;
    sx = e.touches[0].clientX;
    sy = e.touches[0].clientY;
    // Un TOQUE normal entra a la ficha: la segunda foto se ensena al MANTENER
    // pulsado o al DESLIZAR, nunca al tocar y soltar.
    holdOnly = false;
    holdTimer = setTimeout(function () { holdOnly = true; swap(el); }, HOLD_MS);
  }, { passive: true });

  document.addEventListener('touchmove', function (e) {
    if (!node || !e.touches.length) return;
    var dx = e.touches[0].clientX - sx;
    var dy = e.touches[0].clientY - sy;
    // Desplazamiento vertical (scroll de la pagina): ni foto ni nada.
    if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 10) {
      clearHold();
      if (swapped) { node.classList.remove('is-swapped'); swapped = false; }
      node = null;
      return;
    }
    if (Math.abs(dx) >= SWIPE_PX) {
      clearHold();
      holdOnly = false;
      swap(node);
    }
  }, { passive: true });

  function endTouch() {
    clearHold();
    var el = node;
    node = null;
    if (!el || !swapped) return;   // fue un toque limpio: que navegue
    swapped = false;
    // Mantener pulsado = ojeada: al soltar vuelve la foto de portada. El
    // DESLIZAMIENTO si deja la vista cambiada (y otro deslizamiento la
    // devuelve, ver swap()).
    if (holdOnly) el.classList.remove('is-swapped');
    holdOnly = false;
  }

  document.addEventListener('touchend', endTouch, { passive: true });
  document.addEventListener('touchcancel', endTouch, { passive: true });
}());
